import { useState } from "react";
import { ListPlus, ListMinus, ChevronDown, Plus, Minus, Trash2 } from "lucide-react";
import { UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";

interface FieldValidationProps {
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  field?:FieldFrm,
  fields: FieldFrm[];
}

const validationTypes = [ 
  { key: "minLength", label: "Mín caracteres", type: "number"},
  { key: "maxLength", label: "Máx caracteres", type: "number"},
  { key: "min", label: "Valor mínimo", type: "number"},
  { key: "max", label: "Valor máximo", type: "number"},
  { key: "required", label: "Requerido", type: "checkbox"},
  { key: "pattern", label: "Expresión Regular", type: "text"}, 
  { key: "compareField", label: "Comparar con otro campo", type: "custom" }
];

const FieldValidation: React.FC<FieldValidationProps> = ({ register, setValue, watch, field, fields }) => {
  const [forceUpdate, setForceUpdate] = useState(0);

  

  //const watchedValidations = watch("validations") as Record<string, string | number | boolean | undefined> || {};
  const watchedValidations = watch("validations") as FieldValidationRule[] || []; 
  
  const addValidation = () => { 
    const existingTypes = watchedValidations.map(v => v.type);  
    const firstMissing = validationTypes.find(v => {
      return !existingTypes.includes(v.key as ValidationRuleType);
    });  
    if (!firstMissing) return; 

    const newValidation = {
        type: firstMissing.key as ValidationRuleType,
        value: firstMissing.key === "required" ? false : 0,
      };
  
    setValue("validations", [...watchedValidations, newValidation]);
    setForceUpdate(prev => prev + 1);
  };

  /*const addValidation = () => {     
    const watchedKeys = Object.keys(watchedValidations);
    const firstMissingValidation = validationTypes.find(item => !watchedKeys.includes(item.key)); 
    if(!firstMissingValidation?.key){
      return
    } 
    const updatedValidations = { ...watchedValidations, [firstMissingValidation?.key??"valid"]: 1 }; 
    setValue("validations", updatedValidations);
    setForceUpdate((prev) => prev + 1);
    //Object.entries(watchedValidations)
  };
  */
  const removeValidation = (index: number) => {
    const updated = [...watchedValidations];
    updated.splice(index, 1);
    setValue("validations", updated);
    setForceUpdate(prev => prev + 1);
  };

/*
  const removeValidation = (type: string) => {
    const updatedValidations = { ...watchedValidations };
    delete updatedValidations[type];
    setValue("validations", updatedValidations);
    setForceUpdate((prev) => prev + 1);
  };
  */


  
  return (
    <div> 
      <div className="relative">
          <button
            type="button" 
            onClick={addValidation}
            className="absolute -top-10 right-3 btn-inca-secondary shadow-md rounded-full transition-all duration-500 transform"
          >
            <Plus className="w-5 h-5 m-2" strokeWidth={1.5} />
          </button>
      </div> 
      <div className="max-h-48 overflow-y-auto py-2 px-4">
        {watchedValidations.map((validation, index) => (
          <div key={`${validation.type}-${index}`} className="flex items-center py-1">
            <div className="relative w-full"> 
              <select
                className= {`appearance-none w-full border n-fmr-input px-4 pr-4 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}
                value={validation.type}
                onChange={(e) => {
                  const updated = [...watchedValidations];
                  updated[index].type = e.target.value as any;
                  updated[index].value = "";
                  if(String(e.target.value)==='compareField'){
                    updated[index].value =fields[0].field_id;
                    updated[index].operator = ">";
                  } 
                  setValue("validations", updated);
                  setForceUpdate(prev => prev + 1);
                }}
              >
                {validationTypes.map((val) => ( 
                    <option key={val.key} value={val.key} disabled={fields.filter(O=>O.type==='number').length<=0 && val.key==="compareField"?true:false}>{val.label}</option>
                ))}
                 
              </select>
              <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
            </div>

            {validation.type === "required" ? ( 
              <div className="w-48 flex justify-between items-center">
                <input
                  type="checkbox"
                  checked={Boolean(validation.value)}
                  onChange={(e) => {
                    const updated = [...watchedValidations];
                    updated[index].value = e.target.checked;
                    setValue("validations", updated);
                    setForceUpdate(prev => prev + 1);
                  }}
                  className="border w-5 h-5 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700 ml-2"
                /> 
              </div>
            ) : validation.type === "compareField" ?
            (
              <div className="flex gap-2 items-center ml-2 w-full"> 
                
                <div className="relative w-full"> 
                  <select
                    className= {`appearance-none w-full border n-fmr-input px-4 pr-4 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    value={(validation.operator || "")}
                    onChange={(e) => {
                      const updated = [...watchedValidations];
                      updated[index].operator = e.target.value as any;
                      setValue("validations", updated);
                      setForceUpdate(prev => prev + 1);
                    }}
                  > 
                    <option value=">">Mayor que</option>
                    <option value=">=">Mayor o igual</option>
                    <option value="<">Menor que</option>
                    <option value="<=">Menor o igual</option>
                    <option value="==">Igual</option>
                    <option value="!=">Distinto</option>
                  </select>
                  <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
                </div> 
                <div className="relative w-full"> 
                  <select
                    className= {`appearance-none w-full border n-fmr-input px-4 pr-4 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    value={String(validation.value)}
                    onChange={(e) => {
                      const updated = [...watchedValidations];
                      updated[index].value = String(e.target.value);
                      setValue("validations", updated);
                      setForceUpdate(prev => prev + 1);
                    }}
                  > 
                    {fields.map((f) =>
                      f.type === 'number' && f.field_id !== field?.field_id ? 
                        <option key={f.field_id} value={f.field_id}>
                          {f.label}
                        </option>
                      : ""
                    )}
                  </select>
                  <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
                </div>

              </div>
            ) :(
              <input
                type={validationTypes.find(v => v.key === validation.type)?.type || "text"}
                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700 ml-2"
                value={validation.value as string | number}
                onChange={(e) => {
                  const updated = [...watchedValidations];
                  updated[index].value = validation.type === "pattern" ? e.target.value : Number(e.target.value);
                  setValue("validations", updated);
                  setForceUpdate(prev => prev + 1);
                }}
              /> 
            )}
            <button
              type="button"
              onClick={() => removeValidation(index)}
              className="w-9 h-9 btn-inca-secondary shadow-md rounded-full ml-2"
            >
              <Trash2 className="w-5 h-5 m-2" strokeWidth={1.5} />
            </button> 
          </div>
        ))}
      </div>
    </div>
  );
};

export default FieldValidation;
